module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 2